<!-- 模板左边部分列表 -->
<template>
  <div class="TemplatePageLeft">
    <div
      class="createTop"
      @click="goInitTemplate">{{ $t('lang.create') }}</div>
    <!-- 模板列表 -->
    <div
      class="TemplateListWrap"
      v-for="(item, index) in listArr"
      :key="index">
      <div class="titleWrap">
        <div class="title">{{ item.title }}</div>
        <div class="operation">
          <i
            class="iconfont icon-search"
            @click="item.searchFlag = !item.searchFlag"></i>
          <i
            class="iconfont icon-add"
            v-if="item.tag != 'tem'"
            @click="addTemplate(item)"></i>
        </div>
      </div>
      <div
        class="scroll-box"
        :class="item.className" >
        <el-input
          class="search-box"
          :clearable="true"
          v-if="item.searchFlag"
          @clear="getFileList(item.tag)"
          @blur="item.searchFlag = false"
          v-model.trim="item.nameLike"
          auth-typecomplete="off"
          @keyup.enter.native="getFileList(item.tag)" />
        <scroll-list
          :class="{'top-pad': item.searchFlag}"
          class="scroll-list"
          v-if="item.list && item.list.length > 0"
          :list="item.list"
          :info="item"
          v-scroll="item.bindScroll"
        ></scroll-list>
      </div>
    </div>
    <creat-program-tem
      v-if="info.show"
      :info="info"></creat-program-tem>
  </div>
</template>

<script>
import scrollList from './scrollList'
import creatProgramTem from './dialog/creatProgramTem'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import toTips from '@/assets/js/toTipsObj'
export default {
  data () {
    return {
      info: {
        show: false,
        tag: 'tem'
      },
      // region信息
      RegionInfo: {},
      // bindScroll: {
      //     loading: true,
      //     noMore: false,
      //     onScroll: this.getNextPage
      // },
      temList: [],
      mcpList: [],
      listArr: [{
        title: 'Program Templates',
        type: 3,
        folderName: 'Playout/Template',
        tag: 'tem',
        className: 'TemplateList',
        nameLike: '',
        searchFlag: false,
        pageIndex: 1,
        pageSize: 20,
        bindScroll: {
          loading: true,
          noMore: false,
          onScroll: this.getNextTemPage
        },
        list: []
      }
      ]
    }
  },
  components: {
    creatProgramTem,
    scrollList
  },
  computed: mapState({
    State: (state) => state
  }),
  created () {
    this.RegionInfo = this.$BehaviorSyns.getRegionBucket()
    this.getTemplateList()
    // this.getMcpList()
    Bus.$on('refreshTemList', (tag) => {
      this.getFileList(tag)
    })
    Bus.$on('openCreatDialog', (obj) => {
      this.info.show = obj.show
    })
  },
  mounted () {
  },
  methods: {
    getFileList (tag) {
      if (tag == 'tem') {
        this.getTemplateList()
      }
    },
    getMcpList () {
      // this.bindScroll.loading = true
      const params = {
        isDirectory: false,
        region: this.RegionInfo.region,
        service: this.RegionInfo.ServerName,
        bucketId: this.RegionInfo.bucketId,
        type: this.listArr[1].type,
        directoryName: this.listArr[1].folderName,
        nameLike: this.listArr[1].nameLike,
        pageIndex: this.listArr[1].pageIndex,
        pageSize: this.listArr[1].pageSize
      }
      this.axios.post('/file/query-user-files', params, { requestBase: 'GATEWAY' }).then((res) => {
        // this.bindScroll.loading = false
        if (res.data.errorCode === '0x0') {
          if (params.pageIndex >= res.data.result.pages) {
            this.listArr[1].bindScroll.noMore = true
          }
          if (params.pageIndex > 1) {
            this.listArr[1].list = this.listArr[1].list.concat(res.data.result.records)
          } else {
            this.listArr[1].list = res.data.result.records
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    getTemplateList () {
      const params = {
        pageNum: this.listArr[0].pageIndex,
        pageSize: this.listArr[0].pageSize,
        condition: this.listArr[0].nameLike
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/eventTemplate/page', params).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (params.pageIndex >= res.data.result.pages) {
            this.listArr[0].bindScroll.noMore = true
          }
          if (params.pageIndex > 1) {
            this.listArr[0].list = this.listArr[0].list.concat(res.data.result.list)
          } else {
            this.listArr[0].list = res.data.result.list
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch(() => {})
    },
    getNextTemPage () {
      if (this.listArr[0].bindScroll.loading || this.listArr[0].bindScroll.noMore) return
      this.listArr[0].pageIndex += 1
      this.getTemplateList()
    },
    getNextMcpPage () {
      if (this.listArr[1].bindScroll.loading || this.listArr[1].bindScroll.noMore) return
      this.listArr[1].pageIndex += 1
      this.getMcpList()
    },
    addTemplate (item) {
      this.info.show = true
      this.info.tag = item.tag
      Bus.$emit('openCreatDialog', this.info)
    },
    goInitTemplate () {
      Bus.$emit('goTemplateBlank', {
        tag: 'tem',
        type: 'add'
      }, false)
    }
  },
  beforeRouteLeave (to, from, next) {
    Bus.$off('refreshTemList')
    console.warn('websocket-template')
  }
}
</script>

<style scoped lang="less">
.TemplatePageLeft {
  width: 100%;
  height: 100%;
  .createTop {
    width: 100%;
    height: 40px;
    background: #555555;
    line-height: 40px;
    text-align: left;
    padding-left: 20px;
    font-size: 14px;
    color: #33ab4f;
    cursor: pointer;
  }
  .TemplateListWrap {
    width: 100%;
    height: calc((100% - 40px));
    border-top: 1px solid #252525;
    position: relative;
    .search-box{
        position: absolute;
        left: 0;
        top: 40px;
    }
    .scroll-list{
        height: 100%;
        overflow-y: scroll;
        &.top-pad {
            padding-top: 40px;
        }
    }
    .titleWrap {
      width: 100%;
      height: 40px;
      padding: 0 18px 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #555555;
      .title {
        font-size: 14px;
        color: #dfdfdf;
      }
      .operation {
        i {
          font-size: 12px;
        }
        .icon-search {
          margin-right: 12px;
        }
      }
    }
    .TemplateList {
        height: calc(100% - 40px);
        overflow: hidden;
    }
    .TimingList {
        height: calc(100% - 40px);
        overflow: hidden;
    }
    .slateFileList {
        height: calc(100% - 510px);
        overflow: hidden;
    }
    .contentWrap {
      width: 100%;
      height: 28px;
      background: #444444;
      display: flex;
      padding: 0 19px 0 32px;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 12px;
        color: #cccccc;
      }
      .operation {
        display: none;
        i {
          font-size: 13px;
        }
      }
    }
    .contentWrap:hover .operation {
      display: block;
    }
  }
}
</style>
